import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MyServicesState } from '@store/states/my-services.state';

const myServicesSelector = createFeatureSelector<MyServicesState>('myServices');

export const myServicesSelectors = {
  listingDataSuperDataSig: createSelector(myServicesSelector, (state) => state.listingData.superData),
  listingDataSubDataSig: createSelector(myServicesSelector, (state) => state.listingData.subData),
  listingDataFiltersSig: createSelector(myServicesSelector, (state) => state.listingData.filters),
  listingDataErrorSig: createSelector(myServicesSelector, (state) => state.listingData.error),
};
